import { ChartType } from '../../../types/prism';
import { PIVOT_NAMESPACE_CONFIG, V2_NAMESPACE_INDICATORS } from './constants';
export function isV2Migrated(visualProps) {
    if (!visualProps || typeof visualProps !== 'object') {
        return false;
    }
    return V2_NAMESPACE_INDICATORS.some(namespace => namespace in visualProps);
}
export function getNamespaceConfigForChartType(chartType) {
    if (chartType === ChartType.AdvancedPivotTable) {
        return [...PIVOT_NAMESPACE_CONFIG];
    }
    return [];
}
export function isSupportedChartType(chartType) {
    return chartType === ChartType.AdvancedPivotTable;
}
export function isValidMigrationInput(visualProps, chartType) {
    if (!visualProps || typeof visualProps !== 'object') {
        return false;
    }
    return isSupportedChartType(chartType);
}
export function ensureNamespace(targetProps, namespace) {
    if (!targetProps[namespace]) {
        targetProps[namespace] = {};
    }
}
export function moveProperty(sourceProps, targetProps, sourceKey, targetNamespace, targetKey) {
    if (!(sourceKey in sourceProps)) {
        return;
    }
    ensureNamespace(targetProps, targetNamespace);
    const finalTargetKey = targetKey || sourceKey;
    targetProps[targetNamespace][finalTargetKey] = sourceProps[sourceKey];
}
export function shouldSkipPropertyTransformation(sourceKey) {
    const specialKeys = ['global-tooltip', 'display'];
    return specialKeys.includes(sourceKey);
}
//# sourceMappingURL=utils.js.map